var map = {
	"./admin.js": 392,
	"./constructor.js": 72831,
	"./constructor_pick.js": 94239,
	"./dicts.js": 83206,
	"./documents.js": 67261,
	"./integration_more.js": 60905,
	"./myspaceMenuAliases.js": 44358,
	"./operations.js": 72653,
	"./reports.js": 81860,
	"./requests.js": 24773,
	"./warehouse.js": 88524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25729;